import { createAction } from "@reduxjs/toolkit";
import {
  ADD_CHAT_SETTINGS,
  ADD_STICKER_GROUP,
  AddStickerGroupActionType,
  ChatSettingsType,
  EDIT_IS_IN_USER_LIST_STICKER_GROUP,
  EditIsInUserListStickerGroup,
  SET_ATTACHMENT,
  SET_CRAPPER_VISIBILITY,
  SET_CURRENT_TABS_ASIDE,
  SET_EDIT_ID,
  SET_MESSENGER_INFO_CONFIG,
  SET_MESSENGER_PLAYER_AUDIO,
  SET_MESSENGER_THEME,
  SET_MULTI_SESSION,
  SET_SCROLL_INITIALIZED,
  SET_UPDATE_AVAILABLE,
  SetCrapperVisibility,
  SetMessengerAsideTabsType,
  SetMessengerAttachmentActionType,
  SetMessengerEditIdActionType,
  SetMessengerInfoConfigActionType,
  SetMessengerPlayerAudioActionType,
  SetMessengerThemeActionType,
  SetMultiSession,
  SetScrollInitialized,
  SetUpdateAvailable,
} from "./types";

export const setMessengerAsideTabs = createAction<SetMessengerAsideTabsType["payload"]>(SET_CURRENT_TABS_ASIDE);
export const setMessengerAttachment = createAction<SetMessengerAttachmentActionType["payload"]>(SET_ATTACHMENT);
export const setMessengerEditId = createAction<SetMessengerEditIdActionType["payload"]>(SET_EDIT_ID);
export const setMessengerPlayerAudio = createAction<SetMessengerPlayerAudioActionType["payload"]>(SET_MESSENGER_PLAYER_AUDIO);
export const setMessengerTheme = createAction<SetMessengerThemeActionType["payload"]>(SET_MESSENGER_THEME);
export const setMessengerInfoConfig = createAction<SetMessengerInfoConfigActionType["payload"]>(SET_MESSENGER_INFO_CONFIG);
export const addStickerGroup = createAction<AddStickerGroupActionType["payload"]>(ADD_STICKER_GROUP);
export const editIsInUserListStickerGroup = createAction<EditIsInUserListStickerGroup["payload"]>(EDIT_IS_IN_USER_LIST_STICKER_GROUP);
export const editCrapperVisibility = createAction<SetCrapperVisibility["payload"]>(SET_CRAPPER_VISIBILITY);
export const addChatSettings = createAction<ChatSettingsType["payload"]>(ADD_CHAT_SETTINGS);
export const setUpdateAvailable = createAction<SetUpdateAvailable["payload"]>(SET_UPDATE_AVAILABLE);
export const setScrollInitialized = createAction<SetScrollInitialized["payload"]>(SET_SCROLL_INITIALIZED);
export const setMultiSession = createAction<SetMultiSession["payload"]>(SET_MULTI_SESSION);
